/* eslint-disable prettier/prettier */
import React from 'react';

import MenuList from 'components/MenuList';
import MenuListItem from 'components/MenuList/MenuListItem';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails } from 'models/travelDetails';

import { Title, Subtitle, Message } from '../styles';
import { CheckCircleIcon } from './styles';

type Props = {
  travelDetails: TravelDetails;
  isAir: boolean;
  setHelp(type: string): void;
};

const Confirmed = ({ travelDetails, isAir, setHelp }: Props) => {
  const { t } = useStoreTranslation();
  const { eticket, locator } = travelDetails.requester;

  return (
    <>
      <CheckCircleIcon />
      <Title>{t('customerSupport.approvedRequest.title')}</Title>

      <Message>
        {t('customerSupport.reservationNumber')}: {locator || t('tripCard.status.Pending')}
      </Message>

      {isAir ? (
        <>
          <Message>
            {t('travelRequest.eticket')}: {eticket || t('tripCard.status.Pending')}
          </Message>

          {travelDetails.flightSectors?.map((flightSector) => (
            <>
              <Subtitle>
                {flightSector.sectorNumber === 1 ? t('flightsDetails.departure') : t('flightsDetails.return')}
              </Subtitle>
              <Message>
                {t('customerSupport.duration')}: {flightSector.totalDuration}
              </Message>
              <Message>
                {t('customerSupport.includes')}:{' '}
                {flightSector.flights[0].handBaggage
                  ? t('flightSectorBaggage.includedHandBaggage')
                  : t('flightSectorBaggage.notIncludedHandBaggage')}
                {', '}
                {flightSector.flights[0].baggageRestrictions &&
                  flightSector.flights[0].baggageRestrictions.startsWith('0')
                  ? t('flightSectorBaggage.notIncludedWarehouseBaggage')
                  : t('flightSectorBaggage.includedWarehouseBaggage')}
              </Message>
            </>
          ))}
        </>
      ) : (
        <>
          <Message>
            {t('customerSupport.hotel.roomType')}: {travelDetails.hotel?.roomType}
          </Message>
        </>
      )}

      <MenuList embedded>
        <MenuListItem
          onClick={() => {
            setHelp('cancelConfirmed');
          }}
          label={t('customerSupport.cancelReservation.title')}
        />
        <MenuListItem
          onClick={() => {
            setHelp('changeConfirmed');
          }}
          label={t('customerSupport.changeReservation.title')}
        />
      </MenuList>
    </>
  );
};

export default Confirmed;
